import { DateTime } from "luxon";
import React from "react";

import {
  cloudinessFormat,
  humidityFormat,
  pressureFormat,
  rainFormat,
  temperatureFormat,
  windFormat,
} from "../../utils";

const WeatherTable = ({ channel, metric, data, timezone }) => {
  const txid = data.txid;
  const time = DateTime.fromMillis(data.datetime)
    .setZone(timezone)
    .toLocaleString(DateTime.DATETIME_FULL);
  const temp = temperatureFormat(data.conditions.t, metric);
  const humidity = humidityFormat(data.conditions.h);
  const pressure = pressureFormat(data.conditions.p);
  const wind = windFormat(data.conditions.ws, data.conditions.wd, metric);
  const clouds = cloudinessFormat(data.conditions.c);
  const rain = rainFormat(data.conditions.r);

  return (
    <table>
      <tbody>
        <tr>
          <th>Channel</th>
          <td>{channel.id}</td>
        </tr>
        <tr>
          <th>Transaction</th>
          <td>
            <a
              target="_blank"
              href={`https://whatsonchain.com/tx/${txid}`}
              rel="noopener noreferrer"
            >
              {txid}
            </a>
          </td>
        </tr>
        <tr>
          <th>Time</th>
          <td>{time}</td>
        </tr>
        {temp ? (
          <tr>
            <th>Temperature</th>
            <td>{temp}</td>
          </tr>
        ) : undefined}
        {humidity ? (
          <tr>
            <th>Humidity</th>
            <td>{humidity}</td>
          </tr>
        ) : undefined}
        {pressure ? (
          <tr>
            <th>Pressure</th>
            <td>{pressure}</td>
          </tr>
        ) : undefined}
        {rain ? (
          <tr>
            <th>Rain</th>
            <td>{rain}</td>
          </tr>
        ) : undefined}
        {wind ? (
          <tr>
            <th>Wind</th>
            <td>{wind}</td>
          </tr>
        ) : undefined}
        {clouds ? (
          <tr>
            <th>Clouds</th>
            <td>{clouds}</td>
          </tr>
        ) : undefined}
      </tbody>
    </table>
  );
};

export default WeatherTable;
